import styled from "styled-components";
import tech_icons from "../assets/tech_icons.js";
import { useGlobaleContext } from "../context";

const Filters = () => {
  const { languages, filterProjects } = useGlobaleContext();
  const styling = ["css3", "sass", "styled_components"];
  const backEnd = ["node", "mongodb", "express", "mongoose", "php", "laravel"];
  const frontEnd = ["pug", "react", "jquery"];

  // It'd be nice to have a legend on the filtering list for the projects. What does green, orange, etc, mean?Perhaps even replace the tags with svg icons,
  //  since you are already using useof them everywhere else
  // You can also have a tooltip on hover
  // But definitely change the colors to something that makes it clear how things are related: frontend, backend, styles, etc. or something like that.
  //  It doesn't make sense to color-code express with css?

  return (
    <Wrapper className="filters-container">
      {languages.map((language, index) => {
        language = language.replace("-", "_");
        return (
          <Button
            key={index}
            onClick={() => filterProjects(language)}
            title={language}
            className={
              styling.indexOf(language) !== -1
                ? "btn styling "
                : backEnd.indexOf(language) !== -1
                ? "btn back-end"
                : frontEnd.indexOf(language) !== -1
                ? "btn front-end"
                : "btn"
            }
          >
            {" "}
            {/* {language} */}
            <img
              className="tech"
              src={tech_icons[language]}
              alt={language}
            ></img>
          </Button>
        );
      })}
    </Wrapper>
  );
};
const Button = styled.button`
  width: max-content;
  border-radius: var(--border-radius-m);
  color: var(--colors-white);
  border-color: var(--colors-white);
  margin: 0;
  font-size: 1rem;
  padding: 0.3rem;

  &.front-end {
    background-color: var(--colors-red-400);
  }
  &.back-end {
    background-color: var(--colors-green-400);
  }
  &.styling {
    background-color: var(--colors-orange-400);
  }
  .tech {
    width: 32px;
    height: 32px;
    fill: #fff;
  }

  @media (max-width: 812px) {
    font-size: 1.5rem;
    padding: 1rem;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 1rem;
  flex-wrap: wrap;
`;
export default Filters;
